module.exports = __webpack_public_path__ + "static/media/O.77a49095.svg";